<template>
    <div class="impression hml_whplt">
         <div class="publicTop">
            <div class="homeBut" @click="homeButClick">
                <img src="@/assets/img/secondLevelPage/home.gif" alt="">
            </div>
            <div class="swiper-container navBox">
                <ul class="swiper-wrapper">
                    <!-- v-for="(item,index) in allData[firstLevelIndex].dataArr[0].list" -->
                    <li
                    v-for="(item,index) in list"
                    :key="index"
                    :class="['swiper-slide',
                    {active: active == index},'slide1']"
                    @click="navClick(index)"
                    >
                        <span>{{ item.title }}</span>
                        <!-- <div class="xian" v-if="index == 0" :style="{left: xianLeftNum}"></div> -->
                    </li>
                </ul>
            </div>
        </div>
        <transition-group name="impressionBgBg">
            <div v-for="(item,index) in list" :key="index" v-show="active == index" class="impressionBg">
                <img :src="item.cover">
                <div class="cover"></div>
            </div>
        </transition-group>
        <div class="swiper-container impressionSwiper">
            <div class="swiper-wrapper">
                <!--  -->
                <li
                class="swiper-slide"
                v-for="(item,index) in list"
                :key="index"
                @click="slideClick(index)"
                >
                    <img :src="item.cover">
                </li>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import 'swiper/css/swiper.css';
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {
            xianLeftNum: '50%',
            list: [],
            active: 0,
            swiper: null,
            swiper1: null,
        }
    },
    created(){
        // console.log(this.ICON);
        let array = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list;
        array.forEach((item,index) => {
            this.list.push({
                cover: item.thumb,
                title: item.title,
                BgImg: "",
            });
        });
        if(this.levelThreeIndex != 0){
            this.active = this.levelThreeIndex;
            this.xianLeftNum = (this.levelThreeIndex * 100 + 50) + "%";
        }
    },
    mounted(){
        const _this = this;
        
        this.swiper1 = new Swiper('.navBox',{
            slidesPerView: 'auto',
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
        });
        this.swiper = new Swiper('.impressionSwiper', {
			slidesPerView: "auto",
			centeredSlides: true,
            initialSlide: _this.levelThreeIndex,
            on: {
                slideChangeTransitionStart(){
                     // console.log(this.activeIndex);
                    _this.active = this.activeIndex;
                    // _this.xianLeftNum = (this.activeIndex * 100) + "%";
                    // 210%  403% 567
                    switch(this.activeIndex){
                        case 0:
                            _this.xianLeftNum = "50%";
                            break;
                        case 1:
                            _this.xianLeftNum = "170%";
                            break;
                        case 2:
                            _this.xianLeftNum = "290%";
                            break;
                        case 3:
                            _this.xianLeftNum = "408%";
                            break;
                    }
                    console.log(_this.swiper1);
                    try {
                        // this.swiper1
                        if(this.activeIndex >= 2){
                            _this.swiper1.slideTo(this.activeIndex,500,false);
                        }else{
                            _this.swiper1.slideTo(0,500,false);
                        }
                    } catch (error) {
                        if(this.activeIndex >= 2){
                            _this.swiper1[_this.swiper1.length - 1].slideTo(this.activeIndex,500,false);
                        }else{
                            _this.swiper1[_this.swiper1.length - 1].slideTo(0,500,false);
                        }
                    }
                    
                },
                sliderMove(e){
                     // console.log(e);
                },
            },
		});
    },
    methods: {
        slideClick(index){
            this.setIndex({levelThreeIndex: index});
            this.$router.push("/impressionDetails");
        },
        navClick(index){
            try {
                this.swiper.slideTo(index,500,false);
                // this.swiper1
                if(index >= 2){
                    this.swiper1.slideTo(index,500,false);
                }else{
                    this.swiper1.slideTo(0,500,false);
                }
            } catch (error) {
                this.swiper[this.swiper.length - 1].slideTo(index,500,false);
                if(index >= 2){
                    this.swiper1[this.swiper1.length - 1].slideTo(index,500,false);
                }else{
                    this.swiper1[this.swiper1.length - 1].slideTo(0,500,false);
                }
            }
            this.active = index;
            // this.xianLeftNum = (index * 100 + 50) + "%";
            switch(index){
                case 0:
                    this.xianLeftNum = "50%";
                    break;
                case 1:
                    this.xianLeftNum = "170%";
                    break;
                case 2:
                    this.xianLeftNum = "290%";
                    break;
                case 3:
                    this.xianLeftNum = "408%";
                    break;
            }
        },
        homeButClick(){
            this.$router.push({name: 'index'});
        },
        ...publicData.mapMutations(["setIndex"])
    },
    computed: {
        ...publicData.mapState(["allData","firstLevelIndex","secondLevelIndex","levelThreeIndex","playAroundDetailsFlag"])
    },
}
</script>

<style lang="scss" scoped>
.impression{
    display: flex;
    align-items: center;
    .impressionBg{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%) scale(1.1);
        filter: blur(.2rem);
        img{
            height: 100%;
        }
        .cover{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%) scale(1.1);
            background: rgba(8,8,8,.15);
        }
    }
    .publicTop{
        width: 100%;
        height: .92rem;
        background: #fff;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99;
        border-radius:0px 0px .2rem .2rem;
        box-shadow:0px .07rem .06rem 0px rgba(0, 0, 0, 0.09);
        overflow: hidden;
        .navBox{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            padding-left: 1.2rem;
            padding-right: .3rem;
            overflow: hidden;
        }
        ul{
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
            li{
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                white-space: nowrap;
                font-size: .32rem;
                color: rgba(51,51,51,.5);
                position: relative;
                span{
                    padding: .1rem .18rem;
                    transition: all .2s ease;
                }
                &.slide1{
                    width: auto;
                    // margin-right: 6%;
                    &:last-of-type{
                        margin-right: 0;
                    }
                }
                &.slide2{
                    flex: 1;
                }
                .xian{
                    width: .6rem;
                    height: .08rem;
                    background:linear-gradient(0deg,rgba(88,191,167,1) 0%,rgba(112,219,202,1) 100%);
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: 0;
                    transition: all .2s ease;
                }
                &.active{
                    span{
                        color: #fff;
                        background: #44B89E;
                        border-radius: .28rem;
                    }
                }
            }
        }
        .homeBut{
            width: .7rem;
            height: .7rem;
            background: #fff;
            position: absolute;
            left: 0;
            top: 0;
            padding: .14rem .24rem .08rem;
            padding-right: 0;
            box-sizing: content-box;
            z-index: 10;
            
        }
        .mapBut{
            width: .42rem;
            height: .48rem;
            background: #0fc;
            position: absolute;
            right: 0;
            top: 0;
            padding: .22rem 0;
            padding-right: .24rem;
            box-sizing: content-box;
            z-index: 10;
        }
    }
    .impressionSwiper{
        width: 100%;
        height: 10rem;
        .swiper-wrapper{
            display: flex;
            align-items: center;
        }
        li{
            width: 5.8rem;
            height: 9rem;
            box-shadow:0px .12rem .28rem .02rem rgba(39,32,24,0.33);
            margin: 0 .2rem;
            overflow: hidden;
            border-radius: .1rem;
            img{
                height: 100%;
            }
        }
    }
}
.impressionBgBg-enter,.impressionBgBg-leave-to {
	opacity: 0;
}
// 控制元素显示过程中实现的具体动画效果
.impressionBgBg-enter-active,.impressionBgBg-leave-active {
	transition: all .5s ease;
}
// 控制元素完全显示之后的状态(样式、位移信息)
.impressionBgBg-enter-to,.impressionBgBg-leave {
	opacity: 1;
}
</style>